import { render, staticRenderFns } from "./ChangeControlReleased.vue?vue&type=template&id=1c7cdd2e&scoped=true&"
import script from "./ChangeControlReleased.vue?vue&type=script&lang=ts&"
export * from "./ChangeControlReleased.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeControlReleased.vue?vue&type=style&index=0&id=1c7cdd2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7cdd2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
